import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    bold: {
      fontWeight: 'bold'
    },
    marked: {
      fontWeight: 'bold',
      color: theme.palette.error.light
    },
    summary: {
      padding: theme.spacing(1, 2)
    },
    summaryItem: {
      marginRight: theme.spacing(4)
    },
    summaryLabel: {
      display: 'block',
      color: theme.palette.text.secondary
    },
    summaryValue: {
      display: 'block',
      fontWeight: 'bold'
    }
  })
);
